'use client'
import React from 'react'
import { fetchMe } from '@/services/fd-api.service'
import { getUserObjData } from '@common/services/cookies.service'

type User = {
  exhibitorId: number
  name: string
  organisationName: string | null
  role: string
}

type UserContextType = {
  user: User | null
  isLoggedIn: boolean
  loading: boolean
  refreshUser: () => Promise<void>
  clearUser: () => void
}

const UserContext = React.createContext<UserContextType>({} as UserContextType)

const UserContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = React.useState<User | null>(null)
  const [loading, setLoading] = React.useState(true)

  const loadUser = async () => {
    try {
      const response: any = await fetchMe()
      if (response?.success && response?.data) {
        setUser(response.data)
      } else {
        setUser(null)
      }
    } catch {
      setUser(null)
    } finally {
      setLoading(false)
    }
  }

  const clearUser = () => setUser(null)

  React.useEffect(() => {
    loadUser()
  }, [])

  const tnc = getUserObjData('tnc')
  const isLoggedIn = !!user && !!tnc?.privacy && !!tnc?.terms

  return <UserContext.Provider value={{ user, isLoggedIn, loading, refreshUser: loadUser, clearUser }}>{children}</UserContext.Provider>
}

const useUserContext = (): UserContextType => React.useContext(UserContext)

export { useUserContext }
export default UserContextProvider
